import React, { Component, Fragment } from 'react';
import ResponsiveTable from 'Components/ResponsiveTable';
import TripTableHeader from 'Components/TripTableHeader/index';
import { ReactComponent as InfoIcon } from 'Icons/info.svg';
import Overlay from 'Components/Overlay/index';
import Heading from 'Components/Heading';
import { ReactComponent as CloseIcon } from 'Icons/close.svg';
import SubHeading from 'Components/SubHeading';
import Cx from 'classnames';
import { isAdaniWilmar } from 'Utils/';
import SecondaryTripTable from 'Components/SecondaryTripTable';
import AWLMultiMode from 'Components/AWLMultiMode';

import { ACC, CENTURY_PLY, HIKAL, GREEN_PLY, CARGIL, ROQUETTE, BEAM, DEEPAK_PHENOLICS_SAP, POLYCAB, ARDEX } from 'Constants/commonConstants';
import CourierTripTable from 'Components/CourierTripTable';
import { getUser } from 'Utils/storage';
import DisposalProductTripTable from 'Pages/DisposalProduct/index';
import ContainerTrips from 'Components/ContainerTrips';
import { isBeamS, isDesmet } from 'Utils/index';

class TripTable extends Component {
   constructor(props) {
      super(props);
      this.state = {
         searchText: "",
         vehicleType: "",
         vehicleBodyType: "",
         isFiltersShown: false,
         viewLegs: false,
         legs: [],
      }
      this.viewMode = props.viewMode;
   }
   viewLegs = (e, legs) => {
      e.stopPropagation()
      this.setState({ viewLegs: true, legs: legs })
   }
   closeViewLegs = () => {
      this.setState({ viewLegs: false, legs: [] })
   }

   shouldRenderTripHeader = (index, tripsType, isGreenply) => {
      return (
         index === 0 &&
         (tripsType === 1 || (isGreenply && tripsType === 2))
      );
   };
   
   shouldRenderTripLineItem = (tripsType, isGreenply) => {
      return (
         (tripsType === 1 || (isGreenply && tripsType === 2))
      );
   };

   renderSystemSuggestedPrice = (trip, isGreenply, isArdex) => {
      const systemPrice = trip?.biddingDetails?.systemSuggestedPrice;
      const lpp = trip?.lpp;
      const pricingName = trip?.pricingBasisName || '';
      const companyIsGreenplyOrArdex = isGreenply || isArdex;


      if (systemPrice == null) {
         return <span>N/A</span>;
      }


      if (systemPrice === lpp || systemPrice <= lpp) {
         return (
            <span className="green-color">
               ₹{systemPrice}
               <br />
               <span>{pricingName}</span>
            </span>
         );
      }

     
      if (lpp > 0 && systemPrice > 0) {
         return (
            <span className="error-color">
               ₹{systemPrice}
               <br />
               <span>{pricingName}</span>
            </span>
         );
      }

      
      if (companyIsGreenplyOrArdex && (!lpp || lpp === 0)) {
         return (
            <span>
               ₹{systemPrice}
               <br />
               <span>{pricingName}</span>
            </span>
         );
      }

      
      return <span>N/A</span>;
   };


   render() {
      const {
         trips,
         tripsCount,
         offset,
         vehicleTypes,
         vehicleBodyTypes,
         isTripsLoading,
         tripsType,
         addingTrip,
         autoSuggestLocations,
         rfqType,
         rfqServiceType,
         trip,
         addTrip,
         hideAddTrip,
         secondaryContractType,
         deleteAddedTrip,
         secondaryToLocations,
         secondaryUpToKmList,
         addCourierTrip,
			includesOtherCharges,
         otherCosts,
         courierMovements,
         courierModes,
         courierZones,
         courierSlabs,
         courierTrips,
         courierOtherCharges,
         rfqBiddingDetails,
			rfqDetails,
			courierTatWeight,
			courierPriceWeight,
         branchesList,
         couriertripsCount,
         rowZones,
         additionalZones,
         colZones,
         businessVolumes,
         rfq,
         transporters,
         searchGroupsAndTransporters,
         YardToYardConstants,
         pricingBasis,
         containerTypes,
         multiModalMovementTypes,
         depotLocationList,
         plantLocationList,
         currencyTypes,
         selectedNavBranch,
         groups,
         clusterDetails,
         setContainerTrip
      } = this.props;
      const user = getUser();
      const isACC = (user.companyId === ACC);
      const centuryPly = CENTURY_PLY.includes(user.companyId);
      const isCargil = CARGIL.includes(user.companyId);
      const isHIKAL = HIKAL.includes(user.companyId);
      const isRIL = ['737'].includes(user.companyId);
      const withPincode = this.props.rfqDetails.withPincode;
      const isGreenply = GREEN_PLY.includes(user.companyId);
      const beam = BEAM.includes(user.companyId);
      const isPolycab = POLYCAB.includes(user.companyId);
      const { ftlContractType } = rfq.rfqDetails || {};
      const isArdex = ARDEX.includes(user.companyId);

      return (
         <div className="box-shadow br-5 col-1 pl-15 pr-15 pt-15 pb-15 pr">
           {![10].includes(rfqType) && <TripTableHeader
               offset={offset}
               // showLocationFilters={true}
               vehicleTypes={vehicleTypes}
               vehicleBodyTypes={vehicleBodyTypes}
               showPagination={false}
               tripsCount={tripsCount}
               fetchTrips={this.props.fetchTrips}
               viewMode={this.viewMode}
               showAddTrip={this.props.showAddTrip}
               uploadTrips={this.props.uploadTrips}
               downloadTripsUrl={this.props.downloadTripsUrl}
               downloadTrips={this.props.downloadTrips}
               disableAddTrip={tripsType === 2}
               addingTrip={addingTrip}
					rfqType={rfqType}
               includesOtherCharges={otherCosts}
               rfqServiceType={rfqServiceType}
					//otherCosts={otherCosts}
					rfqDetails={rfqDetails}
					courierTatWeight={courierTatWeight}
					courierPriceWeight={courierPriceWeight}
               courierModes={courierModes}
               courierZones={courierZones}
               courierMovements={courierMovements}
               isCourierFilter={true}
               couriertripsCount ={couriertripsCount}
               countText={`${rfqType === 9 ? 'Lanes' : 'Trips'} Found`}
               acceptPartialSolution={this.props.rfqDetails.acceptPartialSolution}
               rfqTypeLtc= {this.props.rfqDetails.rfqTypeLtc}
               withPincode={withPincode}
               biddingPercentageSolution={rfq.rfqDetails.biddingPercentageSolution}
            />}
            {rfqServiceType !== 3 && ![9, 10].includes(rfqType) &&
            <Fragment>
            {rfqType === 3 ?
               <SecondaryTripTable
                  addingTrip={addingTrip}
                  vehicleTypes={vehicleTypes}
                  vehicleBodyTypes={vehicleBodyTypes}
                  secondaryToLocations={secondaryToLocations}
                  secondaryUpToKmList={secondaryUpToKmList}
                  EditTrip={trip}
                  addTrip={addTrip}
                  rfqType={rfqType}
                  rfqServiceType={rfqServiceType}
                  hideAddTrip={hideAddTrip}
                  trips={trips}
                  secondaryContractType={secondaryContractType}
                  showAddTrip={this.props.showAddTrip}
                  deleteAddedTrip={deleteAddedTrip}
                  includesOtherCharges={includesOtherCharges}
                  branchesList ={branchesList}
                  selectedNavBranch={selectedNavBranch}
                  depotLocationList={depotLocationList}
                  plantLocationList={plantLocationList}
                  clusterDetails={clusterDetails}
                  businessVolumes={businessVolumes}
                  pricingBasis={pricingBasis}
               /> :
               <Fragment>
                  {rfqType === 6 ?
                  <AWLMultiMode 
                     addingTrip={addingTrip}
                     businessVolumes={businessVolumes}
                     hideAddTrip={hideAddTrip}
                     rfq={rfq}
                     vehicleTypes={vehicleTypes}
                     vehicleBodyTypes={vehicleBodyTypes}
                     addTrip={addTrip}
                     transporters={transporters}
                     trips={trips}
                     offset={offset}
                     searchGroupsAndTransporters={searchGroupsAndTransporters}
                     YardToYardConstants={YardToYardConstants}
                     editTrip={this.props.editTrip}
                     pricingBasis={pricingBasis}
                     containerTypes={containerTypes}
                     multiModalMovementTypes={multiModalMovementTypes}
                     depotLocationList={depotLocationList}
                     plantLocationList={plantLocationList}
                     viewMode={this.viewMode}
                  />
                  :
                  <ResponsiveTable>
                  {
                     (trips || []).map((trip, index) => {
                        let currencyType = (currencyTypes || []).find(el => el.currency_type === trip.legCostValue) || {};
                        if(rfqDetails && rfqDetails.multiLevelMovementType === 2 && trip.multi_mode_leg_trip && trip.multi_mode_leg_trip.length > 0) {
                           currencyType = (currencyTypes || []).find(el => el.currency_name === trip.multi_mode_leg_trip[0].leg_cost_name) || {};
                        }
                        return (
                           <Fragment key={(index + 1)}>
                              {/* FOR INDIVIDUAL TRIP TYPES */}
                              {this.shouldRenderTripHeader(index, tripsType, isGreenply) && <div className="flex flex-middle mb-20 ">
                                 <div className="fBold fs-16 header-dark-color wt-50 pl-5">Trip</div>
                                 {((trip.rfqServiceType === 1 || [4,5].includes(trip.rfqServiceType)) && !(isHIKAL && rfq.type === 5)) && <div className="fBold fs-16 header-dark-color wt-150  pl-15 ">Vehicle</div>} 
                                 {(trip.rfqServiceType === 1 && isAdaniWilmar()) && <div className="fBold fs-16 header-dark-color wt-150  pl-15 ">Vehicle/Scale Capacity</div>}
                                 {(isHIKAL && rfq.type === 5) && <div className="fBold fs-16 header-dark-color wt-150  pl-15 ">Movement By</div>}
                                 {(trip.rfqServiceType === 1 || [4,5].includes(trip.rfqServiceType)) && <div className="fBold fs-16 header-dark-color wt-150 pl-15">Body Type</div>}
                                 <div className="fBold fs-16 header-dark-color wt-150 pl-15">From</div>
                                 <div className="fBold fs-16 header-dark-color wt-150 pl-15">{ ftlContractType === 2 ? 'From - To Range(Km)' : 'To'}</div>
                                 {isDesmet() && <div className="fBold fs-16 header-dark-color wt-150 pl-15">{'Consignor'}</div>}
                                 {isDesmet() && <div className="fBold fs-16 header-dark-color wt-150 pl-15">{'Consignee'}</div>}
                                 {!isACC && trip.rfqType === 1 && <div className="fBold fs-16 header-dark-color wt-100 pl-15">Distance</div>}
                                 {trip.rfqType === 1 && <div className="fBold fs-16 header-dark-color wt-100 pl-15">LPP</div>}
                                 {(isAdaniWilmar()) && rfqBiddingDetails && rfqBiddingDetails.pricingBasis && rfqBiddingDetails.pricingBasis === 6 && <div className="fBold fs-16 header-dark-color wt-100 pl-15">System Suggested Price</div>}
                                 {(isGreenply  || isArdex)&& rfqBiddingDetails  && <div className="fBold fs-16 header-dark-color wt-100 pl-15">System Suggested Price</div>}
                                 {trip.rfqType === 1 &&<div className="fBold fs-16 header-dark-color wt-100 pl-15">Ceiling Price</div>}
                                 {isBeamS() &&<div className="fBold fs-16 header-dark-color wt-100 pl-15">Diesel Price</div>}
                                 {(user.tk11_routecode_validation || beam ) && <div className="fBold fs-16 header-dark-color wt-100 pl-15">Route Code</div>}
                                 {isPolycab && <div className="fBold fs-16 header-dark-color wt-100 pl-15">Shipment Code</div>}
                                 {trip.rfqType === 1 && <div className="fBold fs-16 header-dark-color wt-150 pl-15">Stops</div>}
                                 {(trip.rfqType === 2 || trip.rfqType === 5) && trip.multi_level_movement_type !== 1 && <div className="fBold fs-16 header-dark-color wt-150 pl-15">No. Of Legs</div>}
                                 <div className="fBold fs-16 header-dark-color wt-150 pl-15">{`Placement${(isHIKAL && rfq.type === 5) ? ' by' : ''}`}</div>
                                 <div className="fBold fs-16 header-dark-color wt-100 pl-15">TAT</div>
                                 <div className="fBold fs-16 header-dark-color wt-100 pl-15">{(isHIKAL && rfq.type === 5) ? 'Chargeable weight / No of Container' : 'Business Volume'}</div>
                                 {trip.rfqType !== 1 &&<div className="fBold fs-16 header-dark-color wt-50 pl-15">Ceiling Price</div>}
                              </div>}
                              {this.shouldRenderTripLineItem(tripsType, isGreenply) && <div className="flex flex-middle border-top-light pt-25 pb-25 bg-hover-theme pr" onClick={() => { if(withPincode !== 1) { this.props.editTrip(trip) } }}>
                                 <div className="fs-14 table-text-color wt-50 pl-5">{index + offset + 1}</div>
                                 {((trip.rfqServiceType === 1 || [4,5].includes(trip.rfqServiceType)) && !(isHIKAL && rfq.type === 5)) && <div className={Cx("fs-14 table-text-color wt-150 pl-15", { 'error-color fBold blinking' : !trip.vehicleTypeName })}>{trip.vehicleTypeName || (((isAdaniWilmar() || isRIL || isGreenply || isCargil) && trip.rfqType === 1) ? 'Vehicle Type Missing' : '')}{((isGreenply ? !trip.requiredVehicleCapacity : !trip.vehicleCapacity) && (centuryPly || isGreenply)) && <div className='error-color fBold blinking mt-3'>{'Vehicle Capacity Missing'}</div>}{(!trip.sap_vehicle_id && centuryPly) && <div className='error-color fBold blinking mt-3'>{'SAP Mapping Id Missing'}</div>}</div>}
                                 {(trip.rfqServiceType === 1 && isAdaniWilmar()) && <div className={Cx("fs-14 table-text-color wt-150 pl-15", { 'error-color fBold blinking' : !trip.vehicleCapacity })}>{trip.vehicleCapacity || ((isAdaniWilmar() && trip.rfqType === 1) ? 'Vehicle Capacity Missing' : '')}{trip.is_existing_contract && <div className='error-color fBold blinking mt-3'>{'Contract Exist'}</div>}</div>}
                                 {(isHIKAL && rfq.type === 5) && <div className="fs-14 table-text-color wt-150 pl-15">{((rfq.rfqDetails || {}).serviceCategoryType == 1 ? rfq.serviceTypeName : 'Air Shipment') || '-'}</div>}
                                 {(trip.rfqServiceType === 1 || [4,5].includes(trip.rfqServiceType)) && <div className={Cx("fs-14 table-text-color wt-150 pl-15", { 'error-color fBold blinking' : !trip.vehicleBodyTypeName })}>{trip.vehicleBodyTypeName|| (((isRIL || centuryPly || isGreenply || isCargil) && trip.rfqType === 1) ? 'Vehicle Body Type Missing' : '')}</div>}
                                 <div className="fs-14 table-text-color wt-150 pl-15">{trip.from} {!trip.from && <span className="error-color fBold blinking">{'From Address is Missing'}</span>} {user.showPinCodeDetails && (trip.stops || []).length > 0 && <><br/><span className="fSemibold">({trip.stops[0].pincode})</span></>}{isAdaniWilmar() && trip.rfqType === 1 && (trip.stops || []).length > 0 && !trip.stops[0].state && <><br/><span className="error-color fBold blinking">{'State is missing'}</span></>}</div>
                                 {ftlContractType !== 2 && <div className="fs-14 table-text-color wt-150 pl-15">{trip.to}{!trip.to && <span className="error-color fBold blinking">{'To Address is Missing'}</span>}{user.showPinCodeDetails && (trip.stops || []).length > 0 && <><br/><span className="fSemibold">({trip.stops[trip.stops.length -1].pincode})</span></>}{isAdaniWilmar() && trip.rfqType === 1 && (trip.stops || []).length > 0 && !trip.stops[trip.stops.length -1].state && <><br/><span className="error-color fBold blinking">{'State is missing'}</span></>}</div>}
                                 {isDesmet() && <div className="fs-14 table-text-color wt-150 pl-15">{(trip.consigners || []).map(consigner => <div className='wt-140 break-word'>{consigner.company_name} - {consigner.address}</div>)}</div>}
                                 {isDesmet() && <div className="fs-14 table-text-color wt-150 pl-15">{(trip.consignees || []).map(consignee => <div className='wt-140 break-word'>{consignee.company_name} - {consignee.address}</div>)}</div>}
                                 {ftlContractType === 2 && <div className="fs-14 table-text-color wt-150 pl-15">{trip.fromRange} - {trip.toRange} {!(trip.fromRange && trip.toRange) && <span className="error-color fBold blinking">{'Enter From and To Range'}</span>}</div>}
                                 {!isACC && trip.rfqType === 1 && trip && <div className="fs-14 fBold table-text-color wt-100 pl-15">{trip.distance} {trip.distanceUOM} {trip.is_km_inserted_by && <Fragment><br/><span>({trip.is_km_inserted_by})</span></Fragment>}</div>}
                                 {trip.rfqType === 1 && trip &&<div className="fs-14 table-text-color wt-110 pl-15">{trip.lpp>0 ? <span>₹{trip.lpp}<br/><span>{trip.pricingBasisName || ''}</span></span>: 'N/A'}
                                 {trip.average_lpp && <div className='theme-color fBold'>Avg. : {trip.average_lpp && trip.average_lpp.toFixed(2) || '-'}</div> || ''}
                                 </div>}
                                 {(isAdaniWilmar()) &&
                                    rfqBiddingDetails?.pricingBasis === 6 && 
                                     (
                                       <div className="fs-14 fBold table-text-color wt-100 pl-15">
                                       {this.renderSystemSuggestedPrice(trip, isGreenply, isArdex)}
                                       </div>
                                 )}
                                 {(isGreenply || isArdex) &&
                                 (
                                       <div className="fs-14 fBold table-text-color wt-100 pl-15">
                                          {this.renderSystemSuggestedPrice(trip, isGreenply, isArdex)}
                                       </div>
                                 )}
                                 {trip.rfqType === 1 && trip.biddingDetails 
                                       && <div className="fs-14 fBold table-text-color wt-100 pl-15"> <span className={Cx('', {
                                          'theme-color': isAdaniWilmar() && trip.biddingDetails.systemSuggestedPrice && trip.biddingDetails.qbr <= trip.biddingDetails.systemSuggestedPrice,
                                          'error-color': isAdaniWilmar() && trip.biddingDetails.systemSuggestedPrice && trip.biddingDetails.qbr > trip.biddingDetails.systemSuggestedPrice,
                                          'error-color fBold blinking': GREEN_PLY.includes(rfq.companyId) && !trip.biddingDetails.qbr 
                                       })}>{trip.biddingDetails.qbr && `₹${Number(trip.biddingDetails.qbr)}` || (GREEN_PLY.includes(rfq.companyId) ? 'Ceiling Price Missing' :'')}<br/><span>{trip.biddingDetails.qbr && trip.pricingBasisName || ''}</span></span>
                                       {isAdaniWilmar() && trip.biddingDetails.qbr && rfqBiddingDetails.pricingBasis === 6 && [6,10].includes(rfq.pricing_bassis_with_qbr_rate_id) && rfq.pricing_basis_qbr_rate && Number(trip.biddingDetails.qbr) > Number(rfq.pricing_basis_qbr_rate) && <><br/><span className="fs-14 error-color fBold blinking">{`Ceiling Price Should be <= ${rfq.pricing_basis_qbr_rate}`}</span></>}
                                 </div>}
                                 {isBeamS() && <div className={Cx("fs-14 table-text-color wt-100 pl-15",{ 'error-color fBold blinking' : !trip.biddingDetails.diesel_price })}>{trip.biddingDetails.diesel_price || 'Diesel Price is Missing'}</div>}
                                 {(user.tk11_routecode_validation || beam ) && <div className={Cx("fs-14 table-text-color wt-100 pl-15",{ 'error-color fBold blinking' : !trip.routeCode })}>{trip.routeCode || 'Route Code is Missing'}</div>}
                                 {isPolycab && <div className={Cx("fs-14 table-text-color wt-100 pl-15")}>{trip.shipment_id || '-'}</div>}
                                 {trip.rfqType === 1 && [1, 4].indexOf(trip.rfqServiceType) > -1 && <div className="fs-14 table-text-color wt-150 pl-15">{trip.noOfPickups} Pickups | {trip.noOfDrops} Drops</div>}
                                 {trip.rfqType === 1 && (trip.rfqServiceType === 2 || trip.rfqServiceType === 3) && <div className="fs-14 table-text-color wt-150 pl-15">{(trip.lclStops || []).length} Stops, {(trip.lclStops || []).map((lclStop) => { return (lclStop.slabs || []).length }).reduce((a, b) => { return a + b })} Slabs</div>}
                                 {(trip.rfqType === 2 || trip.rfqType === 5) && trip.multi_level_movement_type !== 1 && <div className="fs-14 table-text-color wt-150 pl-15">{trip.number_of_legs_count} Legs</div>}
                                 <div className="fs-14 table-text-color wt-150 pl-15">{trip.placementTimeFormatted}</div>
                                 <div className="fs-14 table-text-color wt-100 pl-15">{(trip.biddingDetails.tatUnit && (GREEN_PLY.includes(rfq.companyId) ? trip.biddingDetails.tatValue >= 0 : trip.biddingDetails.tatValue)) ? (`${trip.biddingDetails.tatValue} ${trip.biddingDetails.tatUnitName}`) : 'N/A'}</div>
                                 <div className="fs-14 table-text-color wt-100 pl-15">{(trip.biddingDetails.businessVolumeUnit && trip.biddingDetails.businessVolumeValue) ? (`${trip.biddingDetails.businessVolumeValue} ${trip.biddingDetails.businessVolumeUnitName}`) : (((rfq && ['737'].includes(rfq.companyId) && (rfq.contegory_type || []).find(el => el.name == 'LTC') && !(rfq.rfqDetails || {}).acceptPartialSolution) || centuryPly || (ROQUETTE.includes(user.companyId))) ? <span className='error-color fBold blinking'>{'Please Enter the Business Volume'}</span> : 'N/A')}</div>
                                 <div className="fs-12 fBold table-text-color wt-103 pl-15"> 
                                 {trip.rfqType !== 1  && trip.biddingDetails && (trip.biddingDetails.qbr !== 0) &&  
                                    <span>
                                       {isHIKAL ?
                                       <>
                                          {(trip.rfqType === 5) && trip && trip.multi_mode_leg_trip && trip.multi_mode_leg_trip.length > 1 && <span>Total Cost:</span>}<span>{trip.biddingDetails[`qbr_inr`] && `₹${Number(trip.biddingDetails[`qbr_inr`]).toFixed(2)}` || '-'}</span>
                                       </>
                                       :
                                       <>
                                          {(trip.rfqType === 2 || trip.rfqType === 5) && trip && trip.multi_mode_leg_trip && trip.multi_mode_leg_trip.length > 1 && <span>Total Cost:</span>}<span>{trip.biddingDetails[`qbr${trip.rfqServiceType === 5 ? '_volume_inr' : ''}`] && `₹${Number(trip.biddingDetails[`qbr${trip.rfqServiceType === 5 ? '_volume_inr' : ''}`]).toFixed(2)}` || '-'}</span>
                                       </>}
													{trip.rfqType === 5 && 
                                       <Fragment>
                                          {isHIKAL ?
                                          (trip.biddingDetails.qbr_inr && trip.priceInBaseCurrency !== 'INR') && <><span className="ml-5">{trip.biddingDetails.qbr_inr && `${trip.priceInBaseCurrencySymbol}${Number(trip.priceInBaseCurrency === "USD" ? trip.biddingDetails[`qbr_usd`] : (trip.biddingDetails[`qbr_secondary`] || 0)).toFixed(2)}` || '-'}</span><br></br></>
                                          :
                                          (trip.biddingDetails.qbr && trip.priceInBaseCurrency !== 'INR') && <><span className="ml-5">{trip.biddingDetails.qbr && `${trip.priceInBaseCurrencySymbol}${Number(trip.priceInBaseCurrency === "USD" ? trip.biddingDetails[`qbr_${trip.rfqServiceType === 5 ? 'volume_' : ''}usd`] : (trip.biddingDetails[`qbr_${trip.rfqServiceType === 5 ? 'volume_' : ''}secondary`] || 0)).toFixed(2)}` || '-'}</span><br></br></>
                                          }
														<span className="ml-5 theme-color fs-12 fBold">{this.props.otherCosts ? "(Includes Other Costs)" : "(Excludes Other Costs)"}</span>
													</Fragment>
                                       }
                                 </span>}
                                 {(trip.rfqType === 2 || trip.rfqType === 5) &&
                                       (trip.multi_mode_leg_trip || []).map((legs, index) => {
                                          let total = 0;
                                          let total_usd = 0;
                                          let total_secondary = 0;
                                          let cType = (currencyTypes || []).find(el => el.currency_type == legs.headingChargesUnit) || currencyType || {};
														(otherCosts) && (legs.multi_mode_heading_charges || []).forEach((value) => {
                                             cType = (currencyTypes || []).find(el => el.currency_type == value.headingChargesUnit) || {};
                                             if(trip.rfqType === 2) {
                                                total += Number(value.headingChargesBudget);
                                             } 
                                             // else if(trip.rfqType === 5) {
                                             //   if(value.headingChargesCp_inr!= undefined){
                                             //    total += value.headingChargesCp_inr && Number(value.headingChargesCp_inr);
                                             //   }
                                             //   if(value.headingChargesCp_usd!= undefined){
                                             //    total_usd += value.headingChargesCp_usd && Number(value.headingChargesCp_usd);
                                             //   }
                                             //   if(cType.currency_type === 3 && value.headingChargesCp_secondary != undefined) {
                                             //    total_secondary += value.headingChargesCp_secondary && Number(value.headingChargesCp_secondary);
                                             //   }
                                             // }
                                             
														})
														return(
                                             <Fragment key={(index + 1)}>
                                                {(trip.rfqType === 5 ? legs.leg_budget_cp_inr > 0 : legs.leg_budget > 0) && trip.multi_mode_leg_trip.length > 1 && 
                                                <div className="fs-12 fBold  table-text-color flex tCenter">Leg{index + 1}:
                                                <div className="mt--3">
                                                   {trip.rfqType === 2 && <span>₹{legs.leg_budget + total}</span> }
                                                   {trip.rfqType === 5 && 
                                                   <Fragment>
                                                      {/* <span className="ml-5">₹{((legs.leg_budget_cp_inr || 0) + total).toFixed(2) || 0}</span> 
                                                      {cType.currency_type === 3 ? 
                                                      <span className="ml-5">{cType.currency_symbol}{((legs.leg_budget_cp_secondary || 0) + total_secondary).toFixed(2) || 0}</span> :
                                                      <span className="ml-5">{cType.currency_symbol}{((legs.leg_budget_cp_usd || 0) + total_usd).toFixed(2) || 0}</span>} */}
                                                      {isHIKAL ? <>
                                                         <span className="ml-5">₹{legs.qbr_inr && Number(legs.qbr_inr || 0).toFixed(2) || 0}</span>
                                                         {(legs.leg_cost_name !== 'INR') && <span className="ml-5">{((currencyTypes || []).find(el => el.currency_name === legs.leg_cost_name) || {}).currency_symbol}{legs[`qbr_${legs.leg_cost_name === "USD" ? 'usd' : 'secondary'}`]}</span>}
                                                      </> :
                                                      <>
                                                      <span className="ml-5">₹{(trip.rfqServiceType === 5 && (isHIKAL ? trip.priceInBaseCurrency !== 'INR' : true)) ? legs.qbr_volume_inr : legs.qbr_inr || 0}</span>
                                                      {(trip.priceInBaseCurrency !== 'INR') && <span className="ml-5">{trip.priceInBaseCurrencySymbol}{legs[`qbr_${trip.rfqServiceType === 5 ? 'volume_' : ''}${trip.priceInBaseCurrency === "USD" ? 'usd' : 'secondary'}`]}</span>}
                                                      </>}
                                                   </Fragment>}</div></div>}
                                             </Fragment>
														)
                                          })
                                 }
                                 </div>
                              </div>}


                                 {/* FOR LOT TYPES  */}
                              {!isGreenply && index === 0 && tripsType === 2 && <div className="flex flex-middle mb-20 ">
                                    <div className="fBold fs-16 header-dark-color wt-250 pl-5">Lot</div>
                                    <div className="fBold fs-16 header-dark-color wt-250 pl-5">Lot Name</div>
                                    <div className="fBold fs-16 header-dark-color wt-250 pl-5">No Of Trips</div>
                                    <div className="fBold fs-16 header-dark-color wt-250 pl-15">Business Volume</div>
                                    <div className="fBold fs-16 header-dark-color wt-200 pl-15">Ceiling Price</div>
                                 </div>}
                              {!isGreenply && tripsType === 2 && <div className="flex flex-middle border-top-light pt-25 pb-25 bg-hover-theme pr">
                                    <div className="fs-14 table-text-color wt-250 pl-15">{index + offset + 1}</div>
                                    <div className="fs-14 table-text-color wt-250 pl-15">{trip.lotName}</div>
                                    <div className="fs-14 table-text-color wt-250 pl-15">{trip.tripsCount}</div>
                                    <div className="fs-14 table-text-color wt-250 pl-15">{trip.biddingDetails.businessVolumeUnit ? (`${trip.biddingDetails.businessVolumeValue} ${trip.biddingDetails.businessVolumeUnitName}`) : '-'}</div>
                                    <div className="fs-14 table-text-color wt-200 pl-15">{trip.biddingDetails.qbr || '-'}</div>

                                 </div>
                                 }
                              </Fragment>
                           )
                        })
                     }
                  </ResponsiveTable>}
               </Fragment>
            }
            {!(trips && trips.length > 0) && !isTripsLoading && rfqType !== 3 && rfqType !== 6 && <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No Trip Has Been Added</div>}
            </Fragment> ||
            <Fragment>
            {rfqServiceType === 3 && 
               <CourierTripTable  
                  addCourierTrip={addCourierTrip} 
                  courierMovements={courierMovements} 
                  courierModes={courierModes} 
                  courierZones={courierZones}
                  courierSlabs={courierSlabs}
                  courierTrips={courierTrips}
                  courierOtherCharges={courierOtherCharges}
                  rfqBiddingDetails={rfqBiddingDetails}
                  rowZones={rowZones}
                  additionalZones={additionalZones}
                  colZones={colZones}
               />}
               </Fragment>
            }
            {
               rfqType === 9 && trips.length > 0 &&
               <DisposalProductTripTable 
                  trips={trips || []}
                  onChangeProductTrips={this.props.onChangeProductTrips}
                  groups={groups}
               />
            }
            {
               rfqType === 10 && 
               <ContainerTrips
                  searchGroupsAndTransporters={searchGroupsAndTransporters}
                  transporters={transporters}
                  vehicleTypes={vehicleTypes}
                  rfq={rfq}
                  setContainerTrip={setContainerTrip}
               />
            }
            
         </div>
      )
   }
}

export default TripTable;
